module.exports = __webpack_public_path__ + "img/icon-menu.a7707f3.svg";